export default {
  Model: {
    SLUG: 'slug',
    REVIEW_TEMPLATE: 'reviewTemplate',
    REVIEW_FORM_TEMPLATES: 'reviewFormTemplates',
    RECEIVER_SLUG: 'receiverSlug',
    COMPILER_SLUG: 'compilerSlug',
    CREATOR_SLUG: 'creatorSlug',
    FORM_TYPE: 'formType',
    DUE_BY: 'dueBy',
    PEER_REVIEW_DUE_BY: 'peerReviewsDueBy',
    RECEIVER_VIEWED_AT: 'receiverViewedAt',
    STATE: 'state',
    HISTORY: 'history',
    CREATED_AT: 'createdAt',
    SELF_360: 'self360',
    CAN_CHANGE_COMPILER: 'canChangeCompiler',
    PEER_REVIEW_RECIPIENT_SHARING_SETTING: 'peerReviewRecipientSharingSetting',
    UNLOCKED_AT: 'unlockedAt',
    REVIEW_TEMPLATE_VERSION: 'reviewTemplateVersion',
    REVIEW_CYCLE_SLUG: 'reviewCycleSlug',
  },
  Actions: {
    FETCH_SINGLE_REVIEW_SUCCESS: 'reviews/FETCH_SINGLE_REVIEW_SUCCESS',
    FETCH_REVIEWS_SUCCESS: 'reviews/FETCH_REVIEWS_SUCCESS',
    CREATE_REVIEW_SUCCESS: 'reviews/CREATE_REVIEW_SUCCESS',
    UPDATE_REVIEW_SUCCESS: 'reviews/UPDATE_REVIEW_SUCCESS',
    RECEIVER_VIEWED_REVIEW_SUCCESS: 'reviews/RECEIVER_VIEWED_REVIEW_SUCCESS',
    UPDATE_REVIEW_COMPILER_SUCCESS: 'reviews/UPDATE_REVIEW_COMPILER_SUCCESS',
    DELETE_REVIEW_SUCCESS: 'reviews/DELETE_REVIEW_SUCCESS',
  },
  State: {
    REVIEWS_BY_REVIEW_SLUG: 'REVIEWS_BY_REVIEW_SLUG',
    REVIEW_FORMS_BY_REVIEW_FORM_SLUG: 'REVIEW_FORMS_BY_REVIEW_FORM_SLUG',
  },
};
